<div class="page">
	<!-- HEADER -->
	<div class="ss-header">
		<div class="ss-header-left">
			<button type="button" class="ss-back-btn" (click)="goBack()">
				<i class="fas fa-arrow-left"></i>
			</button>

			<div class="ss-header-title-wrapper">
				<div class="ss-logo">
					<i class="fas fa-warehouse"></i>
				</div>
				<h1 class="ss-title">
					GOODS <span *ngIf="mode == 0">IN</span><span *ngIf="mode == 1">OUT</span> -
					Outside Process
				</h1>
			</div>
		</div>

		<div class="ss-clock">
			<span> {{ dateTime | date: 'EEE d MMM HH:mm' }} </span>
		</div>
	</div>
	<!-- MODE 0: GOODS IN — Receivable movements (full width, two columns) -->
	<div *ngIf="mode == 0" class="receivable-layout">

		<div class="receivable-toolbar">
			<h2 class="receivable-heading">
				<i class="fas fa-inbox" style="margin-right: 10px;"></i>
				Awaiting Receipt
			</h2>
			<span class="receivable-count">{{ filteredReceivableMovements.length }} item{{ filteredReceivableMovements.length !== 1 ? 's' : '' }}</span>
		</div>

		<div class="receivable-search">
			<i class="fas fa-search receivable-search-icon"></i>
			<input type="text" class="receivable-search-input" [(ngModel)]="searchTerm" placeholder="Search by part number or work order..." />
			<button *ngIf="searchTerm" type="button" class="receivable-search-clear" (click)="searchTerm = ''">
				<i class="fas fa-times"></i>
			</button>
		</div>

		<div *ngIf="!isLoading && filteredReceivableMovements.length === 0" class="card" style="text-align:center; padding: 32px;">
			<p>{{ searchTerm ? 'No movements match your search.' : 'No movements waiting to be received.' }}</p>
		</div>

		<div class="receivable-grid">
			<div *ngFor="let movement of filteredReceivableMovements" class="card job-card-base job-green"
				(click)="openReceiveModal(movement)">
				<div class="job-grid">
					<div><span class="label">Part:</span> {{ movement.outsideProcessContract?.part?.partNumber }}</div>
					<div><span class="label">Supplier:</span> {{ movement.supplier?.name }}</div>
					<div><span class="label">Qty Sent:</span> {{ movement.quantitySent }}</div>
					<div><span class="label">Work Order:</span> {{ movement.workOrderStage?.workOrderId }}</div>
					<div *ngIf="movement.dateSent"><span class="label">Date Sent:</span> {{ movement.dateSent | date:'dd MMM yyyy' }}</div>
					<div *ngIf="movement.stillageNumber"><span class="label">Stillage:</span> {{ movement.stillageNumber }}</div>
				</div>
			</div>
		</div>

	</div>

	<div *ngIf="mode == 1" class="layout">

		<!-- LEFT PANEL -->
		<section class="panel panel-left">

			<!-- <div class="card header-card">
				<div class="header-row">
					<div>
						<h1>Job Queue</h1>
						<p>Pending parts waiting to be sent.</p>
					</div>
					<div class="icon-box">
						<i class="fas fa-clipboard-list"></i>
					</div>
				</div>
			</div> -->

			<div class="job-list">
				<button class="btn primary" style="width:100%; margin-left:0px; margin-bottom:20px;"
					[disabled]="isLoading || sendableMovements.length === 0" (click)="openDispatchConfirm()">
					<i class="fas fa-paper-plane" style="margin-right:10px"></i>
					Dispatch Queue
				</button>

				<div *ngFor="let movement of sendableMovements" class="swipe-wrapper">
					<!-- Left action: dispatch single (swipe right) -->
					<div class="swipe-action-left">
						<button type="button" class="swipe-dispatch-btn" (click)="openDispatchSingleConfirm(movement)">
							<i class="fas fa-check"></i>
						</button>
					</div>
					<!-- Right action: delete (swipe left) -->
					<div class="swipe-action">
						<button type="button" class="swipe-delete-btn" (click)="openDeleteConfirm(movement)">
							<i class="fas fa-trash"></i>
						</button>
					</div>
					<div class="card job-card-base job-primary swipe-track"
						[class.swipe-resting]="swipingId !== movement.id"
						[class.swipe-dragging]="swipingId === movement.id"
						[style.transform]="getCardTransform(movement)"
						(mousedown)="onMouseSwipeStart($event, movement)"
						(click)="onCardClick(movement)"
						(touchstart)="onSwipeStart($event, movement)"
						(touchmove)="onSwipeMove($event, movement)"
						(touchend)="onSwipeEnd($event, movement)">
						<div class="job-grid">
							<div><span class="label">Part:</span> {{ movement.outsideProcessContract.part.partNumber }}</div>
							<div><span class="label">Supplier:</span> {{ movement.supplier.name }}</div>
							<div><span class="label">Qty:</span> {{ movement.quantitySent }}</div>
							<div><span class="label">Work Order:</span> {{ movement.workOrderStage.workOrderId }}</div>
							<div *ngIf="movement.stillageNumber"><span class="label">Stillage:</span> {{ movement.stillageNumber }}</div>
						</div>
					</div>
				</div>

				<div *ngIf="!isLoading && sendableMovements.length === 0" class="card" style="text-align:center; padding: 24px;">
					<p>No movements waiting to be sent.</p>
				</div>
			</div>
		</section>

		<!-- RIGHT PANEL -->
		<section class="panel panel-right">

			<!-- <div class="card header-card">
				<div class="header-row">
					<div>
						<h1>QR Code Scanner</h1>
						<p>Scan work order QR codes to start processing</p>
					</div>
					<div class="icon-box">
						<i class="fas fa-qrcode"></i>
					</div>
				</div>
			</div> -->

			<div class="card scanner-card">

				<!-- Scanner Header / Collapse Toggle -->
				<div class="scanner-card-header" [class.scanner-card-header--collapsed]="scannerCollapsed" (click)="scannerCollapsed = !scannerCollapsed">
					<div class="scanner-card-title">
						<i class="fas fa-qrcode" style="margin-right: 8px;"></i>
						QR Code Scanner
					</div>
					<i class="fas" [ngClass]="scannerCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
				</div>

				<!-- Scanner Viewport -->
				<div *ngIf="!scannerCollapsed" class="viewport">

					<!-- Not scanning -->
					<div *ngIf="!scanning" class="center">
						<div class="camera-placeholder">
							<i class="fas fa-camera"></i>
						</div>
						<h3>Camera Ready</h3>
						<p>Click "Start Scanning" to activate camera</p>
					</div>

					<!-- Scanning -->
					<div *ngIf="scanning" class="scanner-live">
						<zxing-scanner #scanner [formats]="[allowedFormats]" [device]="selectedDevice"
							(camerasFound)="cameraFound($event)" (camerasNotFound)="camerasNotFound()"
							(scanSuccess)="onScanSuccess($event)"></zxing-scanner>
						<div class="scanner-overlay">
							<div class="aim-frame">
								<span class="corner tl"></span>
								<span class="corner tr"></span>
								<span class="corner bl"></span>
								<span class="corner br"></span>

								<div class="scan-line"></div>
							</div>

							<div class="aim-hint">
								Align the QR code inside the frame
							</div>
						</div>
						<!-- Optional overlay (purely visual) -->
						<div class="scanner-overlay">
							<div class="scan-frame"></div>
							<!-- <div class="scan-line"></div> -->
						</div>
					</div>

				</div>

				<!-- CONTROLS -->
				<div *ngIf="!scannerCollapsed" class="controls controls-row">
					<button class="btn primary" [class.danger]="scanning" (click)="this.scanning = !this.scanning;">
						<i class="fas" [ngClass]="scanning ? 'fa-stop' : 'fa-play'"></i>
						{{ scanning ? 'Stop Scanning' : 'Start Scanning' }}
					</button>
					<button class="btn ghost" (click)="openManualEntryPin()">
						<i class="fas fa-keyboard" style="margin-right: 8px;"></i>
						Manual Entry
					</button>
				</div>

				<!-- STATUS -->
				<div *ngIf="!scannerCollapsed" class="status" [class.active]="scanning">
					<div class="status-row">
						<span class="dot" [class.pulse]="scanning"></span>
						<span class="status-title">
							{{ scanning ? 'Scanning Active' : 'Scanner Ready' }}
						</span>
					</div>
					<p>
						{{
						scanning
						? 'Camera is active and ready to scan QR codes'
						: 'Position QR code within the scanner frame'
						}}
					</p>
				</div>

			</div>

			<!-- MANUAL ENTRY FOOTER (collapsed state only) -->
			<div *ngIf="scannerCollapsed" class="manual-entry-footer">
				<button class="btn ghost manual-entry-btn" (click)="openManualEntryPin()">
					<i class="fas fa-keyboard" style="margin-right: 8px;"></i>
					Manual Entry
				</button>
			</div>

		</section>

	</div>
</div>
<!-- ===================== -->
<!-- MODALS (DROP-IN)      -->
<!-- ===================== -->

<!-- Modal 1: Stage + Quantity (scan flow) -->
<div class="ss-modal-backdrop" *ngIf="showQtyModal" (click)="closeQtyModal()">
	<div class="ss-modal" (click)="$event.stopPropagation()">
		<div class="ss-modal-header">
			<h2 class="ss-modal-title">Outside Process — Send</h2>
			<button type="button" class="ss-modal-close" (click)="closeQtyModal()">
				<i class="fas fa-times"></i>
			</button>
		</div>

		<div class="ss-modal-body">

			<!-- Work order summary -->
			<div *ngIf="scannedWorkOrder" style="margin-bottom: 16px; padding: 10px 12px; background: #f5f5f5; border-radius: 6px; font-size: 0.85rem;">
				<span class="label">Work Order:</span> {{ scannedWorkOrder.id }}
				&nbsp;&nbsp;
				<span class="label">Part:</span> {{ scannedWorkOrder.part?.partNumber }}
			</div>

			<label class="ss-modal-label">Stage</label>
			<select class="ss-modal-input" [(ngModel)]="selectedStageId">
				<option [ngValue]="null" disabled>Select a stage...</option>
				<option *ngFor="let routerStage of allowedRouterStages" [ngValue]="routerStage">
					OP{{ routerStage * 10 }}
				</option>
			</select>

			<div style="height: 12px;"></div>

			<label class="ss-modal-label">Quantity</label>
			<input class="ss-modal-input" type="number" min="1" [(ngModel)]="qtyToSend" placeholder="0" />

			<div style="height: 12px;"></div>

			<label class="ss-modal-label">Stillage Number <span style="opacity:0.6;">(optional)</span></label>
			<input class="ss-modal-input" type="text" [(ngModel)]="stillageToSend" placeholder="e.g. S-001" />

		</div>

		<div class="ss-modal-footer">
			<button type="button" class="btn ghost" (click)="closeQtyModal()">Cancel</button>
			<button type="button" class="btn primary" [disabled]="!selectedStageId || !qtyToSend || isLoading" (click)="submitQtyModal()">Continue</button>
		</div>
	</div>
</div>

<!-- Modal 2: Manual Work Order Lookup -->
<div class="ss-modal-backdrop" *ngIf="showWoQtyModal" (click)="closeWoQtyModal()">
	<div class="ss-modal" (click)="$event.stopPropagation()">
		<div class="ss-modal-header">
			<h2 class="ss-modal-title">Manual Entry</h2>
			<button type="button" class="ss-modal-close" (click)="closeWoQtyModal()">
				<i class="fas fa-times"></i>
			</button>
		</div>

		<div class="ss-modal-body">
			<label class="ss-modal-label">Work Order ID</label>
			<input class="ss-modal-input" type="number" min="1" [(ngModel)]="manualWorkOrderId"
				placeholder="Enter numeric Work Order ID" />
		</div>

		<div class="ss-modal-footer">
			<button type="button" class="btn ghost" (click)="closeWoQtyModal()">Cancel</button>
			<button type="button" class="btn primary" [disabled]="!manualWorkOrderId || isLoading" (click)="submitWoQtyModal()">
				Look Up
			</button>
		</div>
	</div>
</div>

<!-- Receive Modal -->
<div class="ss-modal-backdrop" *ngIf="showReceiveModal" (click)="closeReceiveModal()">
	<div class="ss-modal" (click)="$event.stopPropagation()">
		<div class="ss-modal-header">
			<h2 class="ss-modal-title">Confirm Receipt</h2>
			<button type="button" class="ss-modal-close" (click)="closeReceiveModal()">
				<i class="fas fa-times"></i>
			</button>
		</div>

		<div class="ss-modal-body">

			<!-- Movement summary -->
			<div style="margin-bottom: 16px; padding: 10px 12px; background: #f5f5f5; border-radius: 6px; font-size: 0.85rem;">
				<div style="margin-bottom: 4px;">
					<span class="label">Part:</span> {{ selectedReceivableMovement?.outsideProcessContract?.part?.partNumber }}
					&nbsp;&nbsp;
					<span class="label">Supplier:</span> {{ selectedReceivableMovement?.supplier?.name }}
				</div>
				<div>
					<span class="label">Work Order:</span> {{ selectedReceivableMovement?.workOrderStage?.workOrderId }}
					&nbsp;&nbsp;
					<span class="label">Qty Sent:</span> {{ selectedReceivableMovement?.quantitySent }}
				</div>
			</div>

			<label class="ss-modal-label">Quantity Received</label>
			<input class="ss-modal-input" type="number" min="1" [(ngModel)]="qtyReceived" placeholder="0" />

		</div>

		<div class="ss-modal-footer">
			<button type="button" class="btn ghost" (click)="closeReceiveModal()">Cancel</button>
			<button type="button" class="btn primary" [disabled]="!qtyReceived || isLoading" (click)="submitReceiveModal()">
				Confirm Receipt
			</button>
		</div>
	</div>
</div>

<!-- Edit Movement Modal -->
<div class="ss-modal-backdrop" *ngIf="showEditModal" (click)="closeEditModal()">
	<div class="ss-modal" (click)="$event.stopPropagation()">
		<div class="ss-modal-header">
			<h2 class="ss-modal-title">Edit Movement</h2>
			<button type="button" class="ss-modal-close" (click)="closeEditModal()">
				<i class="fas fa-times"></i>
			</button>
		</div>
		<div class="ss-modal-body">

			<!-- Movement summary -->
			<div *ngIf="movementToEdit" style="margin-bottom: 16px; padding: 10px 12px; background: #f5f5f5; border-radius: 6px; font-size: 0.85rem;">
				<div style="margin-bottom: 4px;">
					<span class="label">Part:</span> {{ movementToEdit.outsideProcessContract?.part?.partNumber }}
					&nbsp;&nbsp;
					<span class="label">Supplier:</span> {{ movementToEdit.supplier?.name }}
				</div>
				<div>
					<span class="label">Work Order:</span> {{ movementToEdit.workOrderStage?.workOrderId }}
				</div>
			</div>

			<label class="ss-modal-label">Quantity</label>
			<input class="ss-modal-input" type="number" min="1" [(ngModel)]="editQty" placeholder="0" />

			<div style="height: 12px;"></div>

			<label class="ss-modal-label">Stillage Number <span style="opacity:0.6;">(optional)</span></label>
			<input class="ss-modal-input" type="text" [(ngModel)]="editStillage" placeholder="e.g. S-001" />

		</div>
		<div class="ss-modal-footer">
			<button type="button" class="btn ghost" (click)="closeEditModal()">Cancel</button>
			<button type="button" class="btn primary" [disabled]="!editQty || isLoading" (click)="submitEditModal()">Save</button>
		</div>
	</div>
</div>

<!-- Dispatch Single Confirmation Modal -->
<div class="ss-modal-backdrop" *ngIf="showDispatchSingleConfirmModal" (click)="showDispatchSingleConfirmModal = false; movementToDispatchSingle = null">
	<div class="ss-modal" (click)="$event.stopPropagation()">
		<div class="ss-modal-header">
			<h2 class="ss-modal-title">Dispatch Movement</h2>
			<button type="button" class="ss-modal-close" (click)="showDispatchSingleConfirmModal = false; movementToDispatchSingle = null">
				<i class="fas fa-times"></i>
			</button>
		</div>
		<div class="ss-modal-body">
			<p style="margin: 0 0 12px; font-size: 14px; color: #374151;">Are you sure you want to dispatch this movement?</p>
			<div *ngIf="movementToDispatchSingle" style="padding: 10px 12px; background: #f5f5f5; border-radius: 6px; font-size: 0.85rem;">
				<div style="margin-bottom: 4px;">
					<span class="label">Part:</span> {{ movementToDispatchSingle.outsideProcessContract?.part?.partNumber }}
					&nbsp;&nbsp;
					<span class="label">Supplier:</span> {{ movementToDispatchSingle.supplier?.name }}
				</div>
				<div>
					<span class="label">Work Order:</span> {{ movementToDispatchSingle.workOrderStage?.workOrderId }}
					&nbsp;&nbsp;
					<span class="label">Qty:</span> {{ movementToDispatchSingle.quantitySent }}
				</div>
			</div>
		</div>
		<div class="ss-modal-footer">
			<button type="button" class="btn ghost" (click)="showDispatchSingleConfirmModal = false; movementToDispatchSingle = null">Cancel</button>
			<button type="button" class="btn primary" (click)="confirmDispatchSingle()">
				<i class="fas fa-paper-plane" style="margin-right:6px"></i>Dispatch
			</button>
		</div>
	</div>
</div>

<!-- Delete Confirmation Modal -->
<div class="ss-modal-backdrop" *ngIf="showDeleteConfirmModal" (click)="showDeleteConfirmModal = false; movementToDelete = null">
	<div class="ss-modal" (click)="$event.stopPropagation()">
		<div class="ss-modal-header">
			<h2 class="ss-modal-title">Delete Movement</h2>
			<button type="button" class="ss-modal-close" (click)="showDeleteConfirmModal = false; movementToDelete = null">
				<i class="fas fa-times"></i>
			</button>
		</div>
		<div class="ss-modal-body">
			<p style="margin: 0; font-size: 14px; color: #374151;">Are you sure you want to delete this movement?</p>
			<div *ngIf="movementToDelete" style="margin-top: 12px; padding: 10px 12px; background: #f5f5f5; border-radius: 6px; font-size: 0.85rem;">
				<div style="margin-bottom: 4px;">
					<span class="label">Part:</span> {{ movementToDelete.outsideProcessContract?.part?.partNumber }}
					&nbsp;&nbsp;
					<span class="label">Supplier:</span> {{ movementToDelete.supplier?.name }}
				</div>
				<div>
					<span class="label">Work Order:</span> {{ movementToDelete.workOrderStage?.workOrderId }}
					&nbsp;&nbsp;
					<span class="label">Qty:</span> {{ movementToDelete.quantitySent }}
				</div>
			</div>
		</div>
		<div class="ss-modal-footer">
			<button type="button" class="btn ghost" (click)="showDeleteConfirmModal = false; movementToDelete = null">Cancel</button>
			<button type="button" class="btn danger" (click)="confirmDelete()">Delete</button>
		</div>
	</div>
</div>

<!-- Dispatch Confirmation Modal -->
<div class="ss-modal-backdrop" *ngIf="showDispatchConfirmModal" (click)="showDispatchConfirmModal = false">
	<div class="ss-modal" (click)="$event.stopPropagation()">
		<div class="ss-modal-header">
			<h2 class="ss-modal-title">Dispatch Queue</h2>
			<button type="button" class="ss-modal-close" (click)="showDispatchConfirmModal = false">
				<i class="fas fa-times"></i>
			</button>
		</div>
		<div class="ss-modal-body">
			<p style="margin: 0; font-size: 14px; color: #374151;">
				Are you sure you want to dispatch all {{ sendableMovements.length }} movement{{ sendableMovements.length !== 1 ? 's' : '' }} in the queue?
			</p>
		</div>
		<div class="ss-modal-footer">
			<button type="button" class="btn ghost" (click)="showDispatchConfirmModal = false">Cancel</button>
			<button type="button" class="btn primary" (click)="confirmDispatch()">
				<i class="fas fa-paper-plane" style="margin-right:6px"></i>Dispatch
			</button>
		</div>
	</div>
</div>

<!-- PIN AUTH MODAL -->
<div class="qs-modal-backdrop" *ngIf="showPinModal">
	<div class="qs-modal">
		<div class="qs-modal-body">

			<div class="qs-pin-logo">
				<i class="fas fa-lock"></i>
			</div>

			<h3 class="qs-result-title">Enter Your PIN</h3>
			<p class="qs-pin-subtitle">4–8 digit PIN required to continue</p>

			<!-- PIN DOTS -->
			<div class="qs-pin-dots">
				<div
					class="qs-pin-dot"
					*ngFor="let _ of pinSlots; let i = index"
					[ngClass]="{ 'qs-pin-dot-filled': i < pinInput.length }">
				</div>
			</div>

			<div class="qs-pin-error" *ngIf="pinError">{{ pinError }}</div>

			<!-- KEYPAD -->
			<div class="qs-pin-keypad">
				<div class="qs-pin-row">
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('1')">1</button>
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('2')">2</button>
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('3')">3</button>
				</div>
				<div class="qs-pin-row">
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('4')">4</button>
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('5')">5</button>
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('6')">6</button>
				</div>
				<div class="qs-pin-row">
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('7')">7</button>
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('8')">8</button>
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('9')">9</button>
				</div>
				<div class="qs-pin-row">
					<button type="button" class="qs-key-btn qs-key-btn-back" (click)="onBackspace()" [disabled]="pinInput.length === 0">
						<i class="fas fa-backspace"></i>
					</button>
					<button type="button" class="qs-key-btn qs-key-btn-number" (click)="onDigitPress('0')">0</button>
					<button type="button" class="qs-key-btn qs-key-btn-ok" (click)="onOkPress()" [disabled]="!canSubmit()">
						<i class="fas fa-check"></i>
					</button>
				</div>
			</div>

			<!-- ACTIONS -->
			<div class="qs-modal-actions-bottom">
				<button type="button" class="qs-secondary-btn-wide" (click)="onPinCancel()">Cancel</button>
			</div>

		</div>
	</div>
</div>